import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const host =
    window.location.host === "xchge.nysmesonet.org" ||
    window.location.host.split(":")[0] === "localhost";

const domain = host
    ? "https://xchge.nysmesonet.org"
    : "https://chge.nysmesonet.org";

const now = moment.utc();

const SawtiCalendar = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        const fetchData = async () => {

            try {

                setLoading(true);

                const requests = [];

                for (let day = 1; day <= 7; day++) {

                    const model = day <= 2 ? "HRRR" : "GFS";

                    requests.push(
                        fetch(
                            `${domain}/api/index.php/get_sawti_min_max/${day}/${model}`
                        ).then(async (res) => {

                            if (!res.ok) {
                                throw new Error(`Failed day ${day}`);
                            }

                            const json = await res.json();

                            if (json?.error) {
                                throw new Error(json.error);
                            }

                            const max = json?.data?.[0]?.max;

                            if (max == null) {
                                throw new Error("Data old/missing");
                            }

                            return {
                                day,
                                model,
                                max: Number(max),
                            };

                        })
                    );
                }

                const results = await Promise.all(requests);

                setData(results);

            } catch (err) {

                console.error(err);
                setError(err.message);

            } finally {

                setLoading(false);
            }
        };

        fetchData();

    }, []);

    // -------------------------------------------------
    // Color scale
    // -------------------------------------------------
    const getColor = (value) => {

        if (value == null) return "#ccc";
        if (value < 10) return "#88bcda";
        if (value < 20) return "#ffd17b";
        if (value < 30) return "#ff9249";
        if (value < 40) return "#f34e02";
        if (value < 50) return "#ff4040";

        return "#c70053";
    };

    if (loading) {
        return <div>Loading SAWTI forecast...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div
            style={{
                width: "100%",
                fontFamily: "sans-serif"
            }}
        >

            <div
                style={{
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: 600,
                    marginBottom: "10px"
                }}
            >
                SAWTI Forecast
            </div>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns:
                        "repeat(auto-fit, minmax(95px, 1fr))",
                    gap: "8px",
                    width: "100%"
                }}
            >

                {data.map((item) => {

                    const date = now
                        .clone()
                        .add(Number(item.day), "day");

                    return (

                        <div
                            key={item.day}
                            style={{
                                borderRadius: "10px",
                                overflow: "hidden",
                                boxShadow:
                                    "0 1px 4px rgba(0,0,0,0.15)",
                                background: "#5f5f5f",
                                display: "flex",
                                flexDirection: "column",
                                minWidth: 0
                            }}
                        >

                            {/* Calendar Header */}
                            <div
                                style={{
                                    background: "#36373b",
                                    borderBottom:
                                        "1px solid #474747",
                                    // padding: "6px 4px",
                                    textAlign: "center"
                                }}
                            >

                                <div
                                    style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: "#cacaca",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px"
                                    }}
                                >
                                    {date.format("ddd")}
                                </div>

                                <div
                                    style={{
                                        fontSize: "12px",
                                        fontWeight: 700,
                                        color: "#d6d6d6",
                                        lineHeight: 1.1
                                    }}
                                >
                                    {date.format("D")}
                                </div>

                                <div
                                    style={{
                                        fontSize: "11px",
                                        color: "#777"
                                    }}
                                >
                                    {date.format("MMM")}
                                </div>

                            </div>

                            {/* Value Section */}
                            <div
                                style={{
                                    background: getColor(item.max),
                                    color: "white",
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "10px 6px"
                                }}
                            >

                                <div
                                    style={{
                                        fontSize: "30px",
                                        fontWeight: 700,
                                        lineHeight: 1
                                    }}
                                >
                                    {item.max?.toFixed(0)}
                                </div>

                                <div
                                    style={{
                                        marginTop: "6px",
                                        fontSize: "11px",
                                        opacity: 0.9,
                                        letterSpacing: "0.5px"
                                    }}
                                >
                                    {item.model}
                                </div>

                            </div>

                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SawtiCalendar;